import React from 'react';
import { COLLECTING_DATA_TOOLTIP } from 'src/utils';

interface LiftCellProps {
  /** Whether a lift value would be shown at all if the experiment weren't still collecting data. */
  canShowLift: boolean;
  isCollectingData: boolean;
  liftValue: number;
  formatLift: (value: number) => JSX.Element;
}

export function LiftCell({
  canShowLift,
  isCollectingData,
  liftValue,
  formatLift,
}: LiftCellProps): JSX.Element {
  if (!canShowLift) {
    return <>—</>;
  }

  if (isCollectingData) {
    return <span title={COLLECTING_DATA_TOOLTIP}>—</span>;
  }

  return formatLift(liftValue);
}
